import React from 'react'
import styled from 'styled-components'

import Field from '@/core/elements/fields'
import { useRouter, useSearchParams } from 'next/navigation'

const Wrapper = styled.div`
  margin-bottom: 20px;
  padding: 0 0 20px 0;
  line-height: 1;
  max-width: 974px;

  label {
    margin-bottom: 0.75rem;
  }

  @media screen and (max-width: 700px) {
    margin: 0px -20px 20px;
    width: calc(100% + 40px);
  }
`

const OpeningtimesFilter = ({ filters, handleFilter, week }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const activity = searchParams.get('activiteit') || 'all'

  const handleChange = (e) => {
    const value = e.target.value

    // Create a new URLSearchParams instance based on current params
    const params = new URLSearchParams(searchParams.toString())
    // Set the activiteit parameter to the selected value
    params.set('activiteit', value)
    
    // Get current pathname and create new URL with updated params
    const pathname = window.location.pathname
    const newUrl = `${pathname}?${params.toString()}`
    // Update the URL with the new params, without reloading the page
    router.push(newUrl, { scroll: false, shallow: true })

    handleFilter(week.start, value)
  }

  const useFilters = React.useMemo(() => {
    if (!filters?.length || filters?.length == 1) {
      return []
    }

    // Add an 'all' activiteiten to the filter
    return [
      {
        label: 'Toon alle activiteiten',
        name: 'Toon alle activiteiten',
        value: 'all',
        id: 'all',
      },
      ...filters,
    ]
  }, [filters])

  if (!useFilters?.length || useFilters?.length == 1) {
    return null
  }

  return (
    <Wrapper>
      <Field
        variant="select"
        width="smallest"
        label="Filter op activiteiten"
        value={activity}
        handleChange={handleChange}
        id="type"
        name="type"
        options={useFilters}
        placeholder="Kies een activiteit"
        boldlable={true}
      />
    </Wrapper>
  )
}

export default OpeningtimesFilter
